<template>
  <component
    :is="as"
    class="image-container-card"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div class="image-container">
      <img class="fade" v-lazy="{ src: image }" />
    </div>

    <div class="info-container">
      <slot />
    </div>
  </component>
</template>

<script>
export default {
  props: {
    as: String,
    image: String,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.image-container-card {
  @include transition(transform);
  width: 100%;
  border-radius: $border-radius;
  background-color: var(--theme-card);
  color: var(--theme-color);
  box-shadow: $elevation-1;
  display: flex;
  flex-direction: column;
  text-decoration: none;
}

.image-container {
  flex: 1;
  background-color: var(--theme-highlight);
  padding: $gp;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 340px;
  max-height: 340px;
  border-radius: $border-radius $border-radius 0 0;

  img {
    @include transition(transform);
    max-width: 250px;
    max-height: 300px;
    box-shadow: $elevation-1;
    border-radius: $border-radius;
    position: relative;
  }
}

.info-container {
  padding: $gp;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
</style>
